import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/global.css';
import App from './App.js';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('TESSA Lean: #root element missing from index.html');
createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
